import useEditableApplications from './useEditableApplications';

export default function useEditableApplicationByName(name: string) {
  const query = useEditableApplications();
  return {
    ...query,
    data: query.data?.find((app) => app.name === name),
  };
}
